
/**
 * @description Multilanguage prototype
 * ECMA5 tradicional class constructing methodology.
 * This is prototytpe model for ML object.
 * Control it from config file.
 *
 * Predefined location is "js/multilanguage/<NAME>.json"
 * predefined values for <NAME> is defined by pack file name.
 * 'en', 'sr' ...
 */
 export function MultiLanguage() {
  this.currentLanguage = 'en';
  this.store = {};
}

/**
 * @description Multilanguage prototype method label
 */
MultiLanguage.prototype.label = function(wordId) {
  if (typeof wordId === 'undefined') {
    console.error('MultiLanguage error in method label got undefined argument wordId ' +
                  'please add argument wordId in your label method call => ')
  } else if (typeof this.store['wordId'] === 'undefined') {
    console.warn('MultiLanguage error in method label got undefined label field id ' +
                  'please check argument wordId => ', wordId)
  }
};

/**
 * @description Multilanguage prototype method loadLangPack
 * with callback feature
 */
MultiLanguage.prototype.loadLangPack = function(currentPack, onLanguageLoad) {

  var classReference = this;
  var currentPack_ = null;
  if (typeof currentPack === 'undefined') {
    currentPack_ = 'en';
  } else {
    currentPack_ = currentPack;
  }

  var xmlhttp = new XMLHttpRequest();
  xmlhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      var myObj = JSON.parse(this.responseText);
      classReference.store = myObj;
      // Call if defined
      if (typeof onLanguageLoad !== 'undefined') {
        onLanguageLoad();
      }
      
    }
  };
  var pPath = "multilanguage/" + currentPack_ + ".json";
  xmlhttp.open("GET", pPath, true);
  xmlhttp.send();
};


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/js/multilanguage.js
// module id = 1991
// module chunks = 4